import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import {ProductSearchResult, ProductSuggestion} from '../models/search';
import {catchError, map} from 'rxjs/operators';
import {ProductInfo, PRODUCT_TYPE} from '../models/product';


enum API_ACTIONS {
  SUGGEST = 'suggest/product',
  SEARCH = 'admin/search',
  COMPONENT_SEARCH = 'admin/componentsearch',
  PRODUCT_VERSIONS = '/versions'
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private httpClient: HttpClient) {
  }

  public getRecentlyViewedProducts(): Observable<ProductInfo[]> {
    return this.httpClient.get(`${environment.apiUrl}admin/recentlyviewed`)
      .pipe(
        catchError(() => of([])),
        map((products: ProductInfo[]): ProductInfo[] => {
          return products ? products.filter((curProduct: ProductInfo): string => curProduct.smartNumber && curProduct.name && curProduct.version) : [];
        })
      ) as Observable<ProductInfo[]>;
  }

  public getProductVersions(smartNumber: string): Observable<ProductInfo[]> {
    return this.httpClient.get(`${environment.apiUrl}product/${smartNumber}${API_ACTIONS.PRODUCT_VERSIONS}`)
      .pipe(
         catchError(() => of([]))
      ) as Observable<ProductInfo[]>;
  }

  public getProductSuggestions(suggestionQuery: string, limit: string = '0', page: string = '50'): Observable<ProductSuggestion[]> {
    return this.httpClient.get(`${environment.apiUrl}${API_ACTIONS.SUGGEST}`, {
      params: {
        query: suggestionQuery,
        limit,
        page
      },
    }).pipe(
      catchError(() => of([])),
    ) as Observable<ProductSuggestion[]>;
  }

  public searchForSuggestedProduct(selectedSuggestion: ProductSuggestion): Observable<ProductSearchResult[]> {
    return this.httpClient.post(`${environment.apiUrl}${API_ACTIONS.SEARCH}`, selectedSuggestion, {
    }).pipe(
      catchError(() => of([])),
      map((products: ProductSearchResult[]): ProductSearchResult[] => products || [])
    ) as Observable<ProductSearchResult[]>;
  }

  public searchForSuggestedComponent(selectedSuggestion: ProductSuggestion, limit: string = '0', page: string = '50'): Observable<ProductSearchResult[]> {
    return this.httpClient.post(`${environment.apiUrl}${API_ACTIONS.COMPONENT_SEARCH}`, selectedSuggestion, {
      params: {
        limit,
        page
      },
    }).pipe(
      catchError(() => of([])),
      map((components: ProductSearchResult[]): ProductSearchResult[] => {
        return components.map((curComponent): ProductSearchResult => ({
          componentId: curComponent.componentId,
          componentName: curComponent.componentName,
          componentVersion: curComponent.componentVersion,
          ...curComponent.parentProductInfo
        }));
      })
    ) as Observable<ProductSearchResult[]>;
  }

  public getLastModifiedProducts(daysAgo: number = 90, numberOfProducts = 10, userEmail?: string): Observable<ProductInfo[]> {
    return this.httpClient.get(`${environment.apiUrl}item/product/lastedited`,
      {
        observe: 'body',
        params: {
          daysAgo,
          numberOfProducts
        }
      }
    ).pipe(
      catchError(() => of([])),
      map((products: ProductInfo[]): ProductInfo[] => {
        return products;
      })
    ) as Observable<ProductInfo[]>;
  }

  public getRecentlyReleasedProducts(daysAgo: number = 90, numberOfProducts = 10, userEmail?: string): Observable<ProductInfo[]> {
    return this.httpClient.get(`${environment.apiUrl}item/product/recentlyReleased`,
      {
        observe: 'body',
        params: {
          daysAgo,
          numberOfProducts
        }
      }
    ).pipe(
      catchError(() => of([])),
      map((products: ProductInfo[]): ProductInfo[] => {
        return products;
      })
    ) as Observable<ProductInfo[]>;
  }
}
